import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Table from "../../Component/Common/Table";
import Pagination from "../../Component/Common/Pagination";
import ToggleSwitch from "../../Component/Common/ToggleSwitch";
import {
  getOrganizations,
  toggleOrganizationStatus,
} from "../../store/organization/organization.action";
import DataActions from "../../Component/Common/DataActions";
import UserImage from "../../assets/images/no-profile.jpg";

const Organization = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [searchText, setSearchText] = useState("");
  const [debounceSearchText, setDebounceSearchText] = useState("");

  const { organizations, totalOrganizations } = useSelector(
    (state) => state.organization,
  );

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const organizationMapData = [
    {
      Header: "Unique ID",
      Cell: ({ row }) => <p className="mb-0">{row?.uniqueId}</p>,
    },
    {
      Header: "Logo",
      Cell: ({ row }) => (
        <img
          src={row.logo}
          style={{
            height: 40,
            maxWidth: 100,
            objectFit: "cover",
            borderRadius: 5,
          }}
          onError={(e) => (e.target.src = UserImage)}
        />
      ),
    },
    {
      Header: "Name",
      Cell: ({ row }) => <p className="fw-bold mb-0">{row?.name}</p>,
    },
    {
      Header: "Email",
      Cell: ({ row }) => <p className="mb-0">{row?.email}</p>,
    },
    {
      Header: "Phone",
      Cell: ({ row }) => (
        <p className="text-nowrap mb-0">{row?.phone || "-"}</p>
      ),
    },
    // {
    //   Header: "Address",
    //   Cell: ({ row }) => <p className="fw-bold mb-0">{row?.address}</p>,
    // },
    {
      Header: "Website",
      Cell: ({ row }) => <p className="mb-0">{row?.website || "-"}</p>,
    },
    {
      Header: "Onboarding Status",
      Cell: ({ row }) => <p className="mb-0">{row?.registrationStatus}</p>,
    },
    {
      Header: "Total Used",
      Cell: ({ row }) => (
        <div>
          <div>Course : {row.currentUsage.coursesCreated}</div>
          <div>Members : {row.currentUsage.membersAdded}</div>
          <div>Videos : {row.currentUsage.videosAdded}</div>
        </div>
      ),
    },
    {
      Header: "Plan",
      Cell: ({ row }) => (
        <p className="mb-0 text-capitalize">
          {row?.subscriptionId?.planId?.name}
        </p>
      ),
    },
    {
      Header: "Subscription Status",
      Cell: ({ row }) => (
        <p className="mb-0 text-capitalize">{row?.subscriptionId?.status}</p>
      ),
    },
    // {
    //   Header: "Active",
    //   Cell: ({ row }) => (
    //     <ToggleSwitch
    //       checked={row?.isActive}
    //       onChange={() => dispatch(toggleOrganizationStatus(row.id))}
    //     />
    //   ),
    // },
  ];

  useEffect(() => {
    dispatch(
      getOrganizations({
        page,
        limit: size,
        searchText: debounceSearchText,
      }),
    );
  }, [dispatch, page, size, debounceSearchText]);

  // Debouncing for search text
  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      setDebounceSearchText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  return (
    <div className="user-table">
      <div className="user-table-top">
        <DataActions
          searchInputProps={{
            placeholder: "Search ID, Name, Email",
            value: searchText,
            onValueChange: (value) => setSearchText(value),
          }}
        />
      </div>

      <Table
        data={organizations}
        mapData={organizationMapData}
        noDataMessage={"No Organization Found!"}
      />
      <div className="mt-3">
        <Pagination
          totalItem={totalOrganizations}
          activePage={page}
          pageSize={size}
          onActivePageChange={handlePageChange}
          onPageSizeChange={handleRowsPerPage}
        />
      </div>
    </div>
  );
};

export default Organization;
